import React, { useState, useEffect } from "react";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { isMobile } from 'react-device-detect';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./InfoIcon.css";

export default function InfoIcon({
    keyName,
    message,
    ...props
}) {
    const [placement, setPlacement] = useState("right");    
    const popover = (
        <Popover className="info-icon-popover" id={"popover-"+keyName}>
          <Popover.Content>
            {message}
          </Popover.Content>
        </Popover>
    );
    
    useEffect(() => {
        if (isMobile) {
            //mobile is narrower, hence all info icon display at bottom
            setPlacement("bottom")
        }
    }, []);

    return (
        <span className="info-icon">
            <OverlayTrigger
                key={keyName}
                placement={placement}
                trigger={["click", "hover"]}
                overlay={popover}
            >
                <FontAwesomeIcon className="info-icon" color="grey" icon={['fas', 'info-circle']}></FontAwesomeIcon>
            </OverlayTrigger>
        </span>
    );
}
